import { render, staticRenderFns } from "./UserAuthIndexTable.vue?vue&type=template&id=1fbba1ac&scoped=true&"
import script from "./UserAuthIndexTable.vue?vue&type=script&lang=js&"
export * from "./UserAuthIndexTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthIndexTable.vue?vue&type=style&index=0&id=1fbba1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbba1ac",
  null
  
)

export default component.exports